import Login from './login.vue'

// import middlewares
export default [{
  path: '/:action?',
  component: Login,
  name: 'Login'
}]
